const CHAT_WIDGET_SAFE_HEIGHT = 90;
const DESKTOP_APP_BAR_HEIGHT = 48;
const TABLET_APP_BAR_HEIGHT = 64;
const MOBILE_APP_BAR_HEIGHT = 56;

export const EXPANDED_DRAWER_WIDTH = 190;
export const COLLAPSED_DRAWER_WIDTH = 48;
export const MOBILE_BOTTOM_NAV_HEIGHT = 56;

export const DESKTOP_BOTTOM_SAFE_AREA = CHAT_WIDGET_SAFE_HEIGHT;
export const MOBILE_BOTTOM_SAFE_AREA =
  CHAT_WIDGET_SAFE_HEIGHT + MOBILE_BOTTOM_NAV_HEIGHT;

export const SHELL_APP_BAR_HEIGHT = {
  xs: `${MOBILE_APP_BAR_HEIGHT}px`,
  sm: `${TABLET_APP_BAR_HEIGHT}px`,
  md: `${DESKTOP_APP_BAR_HEIGHT}px`,
};

export const SHELL_DRAWER_TOP_OFFSET = SHELL_APP_BAR_HEIGHT;
